<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-page-heading *ngIf="!!setting" [ttModel]="setting.page_heading"></tt-page-heading>
    <tt-list [ttData]="itemsListDeviationTypes"></tt-list>
</tt-page>
